import React from 'react';
import { Card, Nav, Button } from 'react-bootstrap';
import { Demo } from '../types/Demo';

interface SidebarProps {
  activeTab: 'demos' | 'create';
  setActiveTab: (tab: 'demos' | 'create') => void;
  demos: Demo[];
  onRefreshDemos: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  setActiveTab,
  demos,
  onRefreshDemos,
}) => {
  const getThemeCount = (theme: string) => {
    return demos.filter(demo => demo.theme === theme).length;
  };

  return (
    <Card className="sidebar">
      <Card.Body>
        {/* Navigation Tabs */}
        <Nav variant="tabs" className="nav-fill mb-4">
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'demos'}
              onClick={() => setActiveTab('demos')}
            >
              <i className="bi bi-list-ul"></i> Demo Siteler
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'create'}
              onClick={() => setActiveTab('create')}
            >
              <i className="bi bi-plus-circle"></i> Yeni Oluştur
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Statistics */}
        <Card className="stats-card mb-3">
          <Card.Body className="text-center">
            <h5><i className="bi bi-bar-chart"></i> İstatistikler</h5>
            <div className="row text-center mt-3">
              <div className="col-12">
                <h2 className="mb-0">{demos.length}</h2>
                <small>Toplam Demo</small>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Theme Statistics */}
        <Card className="stats-card">
          <Card.Body>
            <h6><i className="bi bi-palette"></i> Tema Dağılımı</h6>
            <div className="mt-3">
              <div className="d-flex justify-content-between">
                <span>Template 1:</span>
                <span>{getThemeCount('template1')}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Template 2:</span>
                <span>{getThemeCount('template2')}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Template 3:</span>
                <span>{getThemeCount('template3')}</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  );
};

export default Sidebar;